import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=402d3f36&scoped=true&"
import script from "./EditIcon.vue?vue&type=script&lang=js&"
export * from "./EditIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402d3f36",
  null
  
)

export default component.exports